export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Estado\",\n    \"label_other\": \"{{count}} estados\"\n}\n"